<div class="row justify-content-center align-items-center" mat-dialog-title>
  <div class="col-md-10 col-10">
    <h5 class="text-left txt-primario">Complemento - {{siniestroConsultado}}</h5>
  </div>
  <div class="col-md-2 col-2 text-right">
    <i (click)="closeDialog('Cancelar')" class="fas fa-times icon-close"></i>
  </div>
</div>
<mat-dialog-content class="py-0">
  <mat-tab-group #ocupantes (selectedTabChange)="onTabChange($event)" mat-stretch-tabs="true" mat-align-tabs="center"
    color="primary">
    @for (opcion of catTabsComplementos; track opcion) {
      <mat-tab [label]="opcion"
        [disabled]="opcion.id == 2 ? !validarTabTercero : false">
        <ng-template mat-tab-label>
          {{opcion.nombre}}
        </ng-template>
        <div class="contenedor-panel">
          @switch (opcion.id) {
            @case (1) {
              <app-crear-actualiza-complemento
                [detalleComplementoSiniestro]="detalleSeccionSiniestroComplemento"
                (eventosActualizaComplemento)="procesaEventosComplemento($event)">
              </app-crear-actualiza-complemento>
            }
            @case (2) {
              <app-crear-actualizar-terceros
                [datosTerceros]="tercerosComplemento">
              </app-crear-actualizar-terceros>
            }
          }
        </div>
      </mat-tab>
    }
  </mat-tab-group>
</mat-dialog-content>
@if (this.tabIndex == 1) {
  <mat-card-actions class="row m-0 p-1 justify-content-end" >
    <div class="col-md-auto d-flex justify-content-end">
      <button color="primary" mat-raised-button type="button" (click)="guardarComplemento()" [disabled]="false">
        Guardar
      </button>
    </div>
  </mat-card-actions>
}